export function trim(str: string, string: string = " "): string
{
    const pattern = '^[' + string + ']*(.*?)[' + string + ']*$';
    return str.replace(new RegExp(pattern), '$1')
}